import { css } from 'lit';

export const styles = css`:host{--track-color: var(--ig-linear-progress-track-color, var(--ig-gray-300));--stripes-color: var(--ig-linear-progress-stripes-color, hsl(from var(--ig-gray-900) h s l/0.7))}`;
